import { PropsWithChildren } from 'react'
import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './BrandWizardVisualAnalysisModal.module.scss'

interface Props extends PropsWithChildren<{ title: string }> {}

export const Section = ({ title, children }: Props) => (
  <div className={Styles.section}>
    <Heading level={5}>{title}</Heading>
    {children}
  </div>
)
